module.exports = __webpack_public_path__ + "static/media/icon_excluir.ac819585.svg";